import HeaderAppyShop, {getComponentStaticProps, HeaderProps} from '../../components/header/headerAppyShop';
import FooterAppyShop from '../../components/footer/footerAppyShop';
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { appyShopConfig } from "../../config";
import { config } from '../../config-merchant';
import { useTranslation } from "next-i18next";
import Meta from '../../components/meta/meta';
import styles from './inspiration.module.scss'
import React from "react";

export default function Inspiration(props: { headerProps: HeaderProps }) {

    const { i18n } = useTranslation('common');
    const { t } = useTranslation('common');

    return (
        <>
            <Meta
                title={"Inspiration"}
                description={config.shopSlogan[i18n.language]}
                image={config.merchantDomain + config.defaultMetaImage}
                metaRobots={true}
            />
            <HeaderAppyShop activepage={'inspiration'} headerProps={props.headerProps} />

            <main className={styles['main-contents']}>

                <img src="/assets/images/astock-cover2.png" className={styles['cover']}/>

                <p className={styles['citation']}>La partition</p>


                <p className={styles['text']}><span className={styles['orel-label']}>Orel</span> s’inspire du folklore traditionnel malien et de l’Afrique, berceau oublié de la parfumerie. Si l’Inde et le Moyen-Orient évoquent des parfums devenus légendaires, peu de parfumeurs se sont tournés vers l’Afrique pour en célébrer les richesses naturelles et lui rendre hommage. Ce riche patrimoine olfactif et culturel subsaharien est le point de départ d’<span className={styles['orel-label']}>Orel</span>. Dans le respect de l’art traditionnel de la parfumerie, les fragrances réinterprètent avec modernité des accords originaux nés d'une palette minimaliste.
                </p>
                <p className={styles['text']}>
                    <span className={styles['orel-label']}>Imzad</span>, <span className={styles['orel-label']}>Do</span>, <span className={styles['orel-label']}>Kora</span> ou <span className={styles['orel-label']}>N’Goni</span> proposent une partition d’accords boisés et audacieux qui unissent harmonieusement des notes voulues fortes. Bois de Cachemire, ciste, benjoin, santal, encens, noix de muscade et musc blanc : ces ingrédients mythiques réunis au sein d’accords inédits esquissent une empreinte olfactive immédiatement reconnaissable.
                </p>


                <p className={styles['text']}>
                De ses producteurs à ses partenaires suisses, <span className={styles['orel-label']}>Orel</span> célèbre la richesse de rencontres et l’entrecroisement des cultures et savoir-faire. Les matières premières sont cultivées et sélectionnées dans le respect des cueilleurs et des artisans, mais aussi de la biodiversité locale.
                </p>
                <p className={styles['text']}>
                De l'idée à la conception, <span className={styles['orel-label']}>Orel</span> n’a fait aucune concession sur le processus de fabrication malgré une réglementation très stricte. Les parfums <span className={styles['orel-label']}>Orel</span> intégralement réalisés à Genève, reposent sur l’expertise de partenaires réputés dont le prestigieux laboratoire Firmenich, Décoform et FCC.
                </p>
                <p className={styles['text']}>
                Pour un sillage sans ostentation, à même d’habiller hommes et femme d’un voile parfumé tout au long de la journée, <span className={styles['orel-label']}>Orel</span> a fait le choix de l’esprit de parfum. Concentré en essence à 20%, l’esprit de parfum, bien moins volatile que l’eau de parfum, se fait élixir. Véritable matérialisation instrumentale, l’esprit de parfum <span className={styles['orel-label']}>Orel</span> vibre à l’unisson avec le corps pour élever l’âme et éveiller la sensualité. <span className={styles['orel-label']}>Orel</span> renoue avec la dimension magique et spirituelle ancestrale du parfum. Le sillage des 4 fragrances induit la présence de son être.
                </p>

                <p className={styles['text']}>
                La note juste tenue, l’accord retentit : chaque esprit de parfum est alors mis en bouteille dans son flacon en verre recyclable aux lignes sobres.
                </p>
                <p className={styles['text']}>
                Les parfums <span className={styles['orel-label']}>Orel</span> affirment le désir de leur créatrice de proposer une parfumerie de matières intimiste dévoilée au fil de compositions facettées.
                </p>

                {/*<p className={styles['img-center']}>
                    <img src="/assets/svg/instruments-all.svg"/>
                </p>*/}

            </main>

            <FooterAppyShop />
        </>
    );
}


export const getStaticProps = async ({ locale }) => {
    if (config.menu.some(item => item.path === 'contact') || config.footerLink.some(item => item.url === '/contact')) {
        return {
            props: {
                ...await serverSideTranslations(locale, ['common']),
                headerProps: await getComponentStaticProps(locale)
            },
            revalidate: appyShopConfig.revalidateData
        }
    } else {
        return {
            notFound: true
        }
    }

}
